module.exports = __webpack_public_path__ + "media/images/mountines_1-c94a03293da6c1b7d63a3365d3187986.png";